module.exports = __webpack_public_path__ + "img/nengyuan.96fd31b0.png";